<template>
  <v-layout
    :class="[$vuetify.breakpoint.mdAndUp ? 'container' : '']"
    align-center
    justify-center
  >
    <v-flex
      xs12
      md11
      lg9
      xl7
    >
      <AddFamilyTemplateHeader
        :data="header"
        :class="{ 'px-3': $vuetify.breakpoint.smAndDown }"
      />
      <v-flex
        xs12
        mb-0
        :mt-5="$vuetify.breakpoint.mdAndUp"
        :mt-3="$vuetify.breakpoint.smAndDown"
        class="stepper__wrapper"
      >
        <v-layout wrap>
          <v-flex
            v-if="isTocVisible"
            xs12
            md3
            lg2
          >
            <AddFamilyTOC :content="tocContent" />
          </v-flex>
          <v-flex
            xs12
            :md9="isTocVisible"
            :lg10="isTocVisible"
          >
            <AddFamilyTemplateContent>
              <template #content>
                <slot name="content" />
              </template>
            </AddFamilyTemplateContent>
            <AddFamilyTemplateActions class="mt-3">
              <template #actions>
                <slot name="actions" />
              </template>
            </AddFamilyTemplateActions>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import AddFamilyTemplateHeader from '@/components/addFamily/addFamilyTemplate/AddFamilyTemplateHeader';
import AddFamilyTemplateContent from '@/components/addFamily/addFamilyTemplate/AddFamilyTemplateContent';
import AddFamilyTemplateActions from '@/components/addFamily/addFamilyTemplate/AddFamilyTemplateActions';
import AddFamilyTOC from '@/components/addFamily/AddFamilyTOC';

export default {
    name: 'AddFamilyTemplate',
    components: {
        AddFamilyTemplateHeader,
        AddFamilyTemplateContent,
        AddFamilyTemplateActions,
        AddFamilyTOC
    },
    inject: ['$validator'],
    props: {
        header: {},
        isTocVisible: {
            default: true
        },
        internal: {
            default: true
        }
    },
    computed: {
        aboutFamilyStepTitle () {
            if (this.$vuetify.breakpoint.xs) {
                return this.$t('forms_steps.mobile.about_family');
            }
            return this.$t('forms_steps.about_family');
        },
        tocContent () {
            return this.internal ? this.internalTOC : this.externalTOC;
        },
        internalTOC () {
            return [
                {
                    title: this.$t('forms_steps.consent'),
                    to: 'family-consent',
                    visibility: true
                },
                {
                    title: this.$t('forms_steps.family_data'),
                    to: 'family-details',
                    visibility: true
                },
                {
                    title: this.$t('forms_steps.source'),
                    to: 'family-source',
                    visibility: true
                },
                {
                    title: this.aboutFamilyStepTitle,
                    to: 'family-information',
                    visibility: true
                }
            ];
        },
        externalTOC () {
            return [
                {
                    title: this.$t('forms_steps.your_data'),
                    to: 'family-reporter-external',
                    visibility: true
                },
                {
                    title: this.$t('forms_steps.consent'),
                    to: 'family-consent-external',
                    visibility: true
                },
                {
                    title: this.$t('forms_steps.family_data'),
                    to: 'family-details-external',
                    visibility: true
                },
                {
                    title: this.aboutFamilyStepTitle,
                    to: 'family-information-external',
                    visibility: true
                }
            ];
        }
    }
};
</script>

<style scoped></style>
